let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aSgRm")).then(() => parcelRequire('01sab'));